function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(9)",
  fill: "currentColor"
}, React.createElement("path", {
  fillRule: "evenodd",
  d: "M0 0h2v20H0V0z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 9)",
  fill: "currentColor"
}, React.createElement("path", {
  fillRule: "evenodd",
  d: "M20 0v2H0V0h20z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/icon-plus.5363808e.svg";
export { SvgComponent as ReactComponent };